module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cta cta-large">\n    <div class="cta__image">\n        <img class="responsiveImage responsiveImage-scale" src="'+
((__t=(img ))==null?'':_.escape(__t))+
'" alt="" />\n    </div>\n    <div class="cta__content">\n        <h3>Create your own activity</h3>\n        <span>Have an idea for an upcoming activity?</span>\n        <span class="u-hideBelowTablet-inline">As a group member, feel free to organize it yourself.</span>\n    </div>\n    <div class="cta__action">\n        <a href="'+
((__t=(link.createActivity ))==null?'':_.escape(__t))+
'" class="t-create-activity-button btn">Create activity</a>\n    </div>\n</div>\n';
}
return __p;
};
